import { render, staticRenderFns } from "./contactCenShfw.vue?vue&type=template&id=28ec39de&scoped=true&"
import script from "./contactCenShfw.vue?vue&type=script&lang=js&"
export * from "./contactCenShfw.vue?vue&type=script&lang=js&"
import style1 from "./contactCenShfw.vue?vue&type=style&index=1&id=28ec39de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ec39de",
  null
  
)

export default component.exports